import React from 'react'
import InputField from './input-field.jsx'

class CounterField extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      haveFocus: false
    },
    this.defaultMinimum = '0'
  }

  onMinusClick(){
    const min = parseInt(this.props.minimumValue) || parseInt(this.defaultMinimum)
    var newVal = Math.max(parseInt(this.props.value)-1, min).toString()
    this.setState({value: newVal}, () => {
      if (this.props.onChange) {
        this.props.onChange(newVal)
      }
    })
  }

  onPlusClick(){
    var newVal = (parseInt(this.props.value)+1).toString()
    this.setState({value: newVal}, () => {
      if (this.props.onChange) {
        this.props.onChange(newVal)
      }
    })
  }

  onInputChange(val){
    if (this.props.onChange) {
      if (this.state.hasFocus) {
        this.props.onChange(val)
      }
      else {
        this.props.onChange(this.getInitialNumberString(val))
      }
    }
  }

  onFocus(){
    this.setState({hasFocus: true}, () => {
      if (this.props.onChange) {
        this.props.onChange(this.props.value)
      }
    })
  }

  getMinValue(){
    if (this.props.minimumValue) {
      return this.props.minimumValue
    }
    else {
      return this.defaultMinimum
    }
  }

  getInitialNumberString(str){
    var nanStart = -1
    for (var i = 0; i < str.length; i++) {
      var c = str.charAt(i)
      if (isNaN(c)) {
        nanStart = i
        break
      }
    }

    var numString = str
    if (nanStart >= 0) {
      // Only numbers, no problem
      numString = str.substring(0, nanStart)
    }

    if (parseInt(numString) < parseInt(this.getMinValue())) {
      return this.getMinValue()
    }

    return numString
  }

  onBlur(){
    this.setState({hasFocus: false}, () => {
      // Check if we have a decent value
      if (!this.props.value || this.props.value.length <= 0) {
        if (this.props.onChange) {
          this.props.onChange(this.getMinValue())
        }
        return
      }

      if (this.props.onChange) {
        this.props.onChange(this.getInitialNumberString(this.props.value))
      }
    })
  }

  onEnter(){
    this.inputField.blur()
  }

  render(){
    var className = 'counter-field'
    if (this.props.className) {
      className += ' ' + this.props.className
    }

    var valString = ''
    if (this.state.hasFocus) {
      valString = this.props.value
    }
    else {
      var val = this.props.minimumValue || this.defaultMinimum
      if (this.props.value) {
        val = this.props.value
      }
      valString = `${val} ${this.props.postfix}`
    }

    return (
      <div className={className}>
        <InputField
          ref={inputField => this.inputField = inputField}
          onChange={this.onInputChange.bind(this)}
          onBlur={this.onBlur.bind(this)}
          onFocus={this.onFocus.bind(this)}
          onEnter={this.onEnter.bind(this)}
          value={valString} />
        <button className='minus' onClick={this.onMinusClick.bind(this)}>-</button>
        <button className='plus' onClick={this.onPlusClick.bind(this)}>+</button>
      </div>
    )
  }
}

export default CounterField
